<template>
  <div
    ref="parallaxWrapper"
    :class="{
      'parallax-wrapper': true,
    }"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import type { AnimatedImageBlockTheme } from '~/sanity/types';
import { applyAnimation } from './Animation';

const props = defineProps<{ theme?: AnimatedImageBlockTheme }>();
const parallaxWrapper = ref<HTMLElement | null>(null);
// Register ScrollTrigger
gsap.registerPlugin(ScrollTrigger);

onMounted(() => {
  applyAnimation(props.theme?.animation, parallaxWrapper); // Apply the animation when the component is mounted
});
</script>

<style lang="scss" scoped></style>
